var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"language-select ma-0 pa-0",attrs:{"value":_vm.getLanguageCode,"items":[
        {'languageCode': 'da', 'languageName': 'Dansk'},
       {'languageCode': 'no', 'languageName': 'Norsk'},
    {'languageCode': 'se', 'languageName': 'Svenska'},
    {'languageCode': 'en', 'languageName': 'English'},],"item-value":"languageCode","item-text":"languageName","placeholder":_vm.$t('misc.language'),"hide-details":"","outlined":"","dense":""},on:{"change":_vm.changeLookAndFeel}})
}
var staticRenderFns = []

export { render, staticRenderFns }